import React, { useCallback, useState } from "react";
import { DashboardDateSelectionContext } from "./DashboardDateSelectionContext";
import { loadDateSelection, saveDateSelection, type DashboardDateSelection } from "./dateSelection";

/** Key this provider by the signed-in user and workspace to isolate saved preferences. */
export default function DashboardDateSelectionProvider({
  storageKey,
  children,
}: {
  storageKey: string;
  children: React.ReactNode;
}) {
  const [selection, setSelection] = useState(() => loadDateSelection(storageKey));
  const remember = useCallback(
    (next: DashboardDateSelection) => {
      setSelection(next);
      saveDateSelection(storageKey, next);
    },
    [storageKey],
  );
  return (
    <DashboardDateSelectionContext.Provider value={{ selection, remember }}>
      {children}
    </DashboardDateSelectionContext.Provider>
  );
}
